import PropTypes from 'prop-types'
import Link from 'next/link'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Breadcrumbs from '@components/breadcrumbs'
import SearchCourse from '@components/search-course'
import states from '@config/states'
import { convertFromSlug } from '@utils/slugs'

function GolfCoursesLayout(props) {
  const {
    children,
    data,
  } = props
  const { query } = data
  const stateName = query && query.state && states[query.state.toUpperCase()]

  return (
    <div>
      <Box py={[4, 4, 6]} bgcolor="white">
        <Container>
          <Box mb={[4, 4, 6]}>
            <Breadcrumbs component={Breadcrumbs}>
              <Link href="/play" data-testid="play-page-link">Play</Link>
              {query.state && (
                <Link href={`/play/${query.state}`}>{stateName || '-'}</Link>
              )}
              {query.city && (
                <Box color="text.primary" component="span">{convertFromSlug(query.city)}</Box>
              )}
              {query.searchText && (
                <Box color="text.primary" component="span">SEARCH</Box>
              )}

            </Breadcrumbs>
          </Box>

          <Box mb={[4, 4, 6]}>
            <SearchCourse dark withTabs />
          </Box>

          { children }
        </Container>
      </Box>
    </div>
  )
}

GolfCoursesLayout.propTypes = {
  children: PropTypes.any,
  data: PropTypes.shape({
    breadcrumb: PropTypes.array,
    query: PropTypes.shape({
      searchText: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
    }),
  }),
}

export default GolfCoursesLayout
